var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import Ribbon from '@widgets/ribbon';
import { Link } from '@ambiguous/link';
import React from 'react';
import Button from '@widgets/button/button';
import RibbonSeparator from '@widgets/ribbon/ribbonSeparator';
import { useA11yContext } from '@assets/spa/context/a11y';
import ImageEl from '@assets/tsx/image';
function PageTopLtg({ image, description, title, buttons, prefetch }) {
    const { breadcrumbs, title: prefetchTitle } = prefetch || {};
    const [state] = useA11yContext();
    const has_image = (image === null || image === void 0 ? void 0 : image.url) && (state === null || state === void 0 ? void 0 : state.illustrations) === true;
    return (React.createElement("div", { className: `ltg-page-top${has_image ? ' has-image' : ''}` },
        React.createElement("div", { className: "container" },
            React.createElement("div", { className: "ltg-page-top-content" },
                React.createElement(Text, { breadcrumbs: breadcrumbs, title: title, prefetchTitle: prefetchTitle, description: description, buttons: buttons }),
                React.createElement("div", { className: "ltg-page-top-ribbon-wrap" },
                    React.createElement(Ribbon, { side: 'top' }),
                    React.createElement(Ribbon, { side: 'bottom', color: 'black' })),
                has_image && React.createElement(Image, { image: image })))));
}
function PageTopMuseum({ image, description, title, buttons, prefetch }) {
    const { breadcrumbs, title: prefetchTitle } = prefetch || {};
    const [state] = useA11yContext();
    const has_image = (image === null || image === void 0 ? void 0 : image.url) && (state === null || state === void 0 ? void 0 : state.illustrations) === true;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: `ltg-page-top${has_image ? ' has-image' : ''} ltg-page-top--museum` },
            React.createElement("div", { className: "container" },
                React.createElement("div", { className: "ltg-page-top-content" },
                    React.createElement(Text, { breadcrumbs: breadcrumbs, title: title, prefetchTitle: prefetchTitle, description: description, buttons: buttons }),
                    React.createElement("div", { className: "ltg-page-top-ribbon-wrap" },
                        React.createElement(RibbonSeparator, { vertical: true })),
                    has_image && React.createElement(Image, { image: image }))))));
}
function PageTopGtc({ image, description, title, buttons, prefetch }) {
    const { breadcrumbs, title: prefetchTitle } = prefetch;
    const [state] = useA11yContext();
    const has_image = (image === null || image === void 0 ? void 0 : image.url) && (state === null || state === void 0 ? void 0 : state.illustrations) === true;
    return React.createElement("div", { className: `ltg-page-top ltg-page-top--gtc${has_image ? ' has-image' : ''}` },
        React.createElement("div", { className: "container" },
            React.createElement("div", { className: "ltg-page-top-content" },
                React.createElement(Text, { breadcrumbs: breadcrumbs, title: title, prefetchTitle: prefetchTitle, description: description, buttons: buttons }),
                has_image ?
                    React.createElement(Image, { image: image }) :
                    React.createElement("div", { className: "ltg-page-top-dots-wrap" },
                        React.createElement("div", { className: "ltg-page-top-dots" })))),
        has_image && React.createElement(RibbonSeparator, { color_left: 'white', color_right: 'primary' }));
}
function Text({ breadcrumbs, title, prefetchTitle, description, buttons }) {
    return (React.createElement("div", { className: "ltg-page-top-text" },
        React.createElement("div", { className: "ltg-page-top-breadcrumbs" }, breadcrumbs === null || breadcrumbs === void 0 ? void 0 : breadcrumbs.map(({ text, slug: url }, index) => {
            return (React.createElement(Link, { href: url, key: text + url }, index === 0 ? React.createElement("i", { className: 'fas fa-home' }) : text));
        })),
        React.createElement("div", { className: "ltg-page-top-text-content" },
            React.createElement("h1", { className: "ltg-page-top-title" }, title || prefetchTitle),
            description && React.createElement("div", { className: "ltg-page-top-description", dangerouslySetInnerHTML: { __html: description } }),
            buttons && React.createElement(ButtonWrap, { buttons: buttons }))));
}
function Image({ image }) {
    return (React.createElement("div", { className: "ltg-page-top-img-wrap" },
        React.createElement(ImageEl, { src: image.url, alt: image.alt, className: "ltg-page-top-img" })));
}
function ButtonWrap({ buttons }) {
    return (React.createElement("div", { className: "ltg-page-top-button-wrap" }, (buttons === null || buttons === void 0 ? void 0 : buttons.length) > 0 && buttons.map((_a) => {
        var { _id } = _a, rest = __rest(_a, ["_id"]);
        return (React.createElement(Button, Object.assign({ key: _id }, rest)));
    })));
}
let PageTop = PageTopLtg;
switch (THEME) {
    case ('gtc'):
        PageTop = PageTopGtc;
        break;
    case ('museum'):
        PageTop = PageTopMuseum;
        break;
}
export { PageTop as default };
